//AJAX 프레임
import { ajaxFrame } from '../lib/ajaxForm';
//로딩 액션
import { AjaxLoading } from '../../../actions/Interactions/loading';
//데이터 API 목록
import { dataUrl } from '../dataUrl';

var listData = {};
var popUpId = null;
var groupId = '#advId';
var advId = $(groupId).val();
var length = 50;
var checkType;

export const createFunc = {
	init:function() {
	},
	//데이터 생성 리스트
	createListCall:function(dataId, type) {
		advId = $(groupId).val();
		var param = "?adv_id=" + dataId;
		var dataApi = dataUrl.createAPI('GET','history', param);
		if(type != 'sync') {
			AjaxLoading.pageLoading();
		}
		ajaxFrame.ajaxDataCall('GET', dataApi, 'json', true, createFunc.createHistoryCallBack);
		createFunc.createDayCheckData('day');
		createFunc.createWeekCheckData('week');
		setTimeout(function() {
			$(".create-date-td").dateRangeCustomPicker({single: false, autoClose:false});
		}, 500);
	},
	createListReData:function() {
		var param = "?adv_id=" + advId;
		var dataApi = dataUrl.createAPI('GET','history', param);
		AjaxLoading.pageLoading();
		setTimeout(function() {
			ajaxFrame.ajaxDataCall('GET', dataApi, 'json', true, createFunc.createHistoryCallBack);
			createFunc.createDayCheckData('day');
			createFunc.createWeekCheckData('week');
		}, 500);
	},
	//데이터 생성(생성)
	createAddData:function(data) {
		var valSplit = data.split('~');
		var firstDate = valSplit[0];
		var lastDate = valSplit[0];
		if(valSplit[1] != undefined){
			lastDate = valSplit[1];
		}
		var request = {
			"adv_id":advId,
			"type":"custom",
			"data":{
				"from_date":firstDate,
				"to_date":lastDate
			}
		};
		var dataApi = dataUrl.createAPI('POST', 'add');
		AjaxLoading.pageLoading('time');
		ajaxFrame.ajaxDataCall('POST', dataApi, 'json', true, createFunc.createAddCallBack, request);
	},
	//데이터 생성(저장)
	createSaveData:function() {
		var daily = $('#daily').prop('checked');
		var weekly = $('#weekly').prop('checked');
		var request = {
			"adv_id":advId,
			"type":"reservation",
			"data":{
				"day":daily,
				"week":weekly
			}
		};
		var dataApi= dataUrl.createAPI('POST', 'save');
		AjaxLoading.pageLoading('time');
		ajaxFrame.ajaxDataCall('POST', dataApi, 'json', true, createFunc.createSaveCallBack, request);
	},
	//데이터 리스트 삭제(단일)
	createListDeleteData:function(obj) {
		var dataApi= dataUrl.createAPI('DELETE', 'history', obj);
		var dataSplit = dataApi.split('?');
		var dataParam = dataSplit[1];
		ajaxFrame.ajaxDataCall('PUT', dataApi, 'json', true, createFunc.createListDeleteCallBack, dataParam);
	},
	//데이터 리스트 전체 삭제
	createListAllDeleteData:function(obj) {
		var dataApi= dataUrl.createAPI('DELETE', 'history', obj);
		var dataSplit = dataApi.split('?');
		var dataParam = dataSplit[1];
		ajaxFrame.ajaxDataCall('PUT', dataApi, 'json', true, createFunc.createListAllDeleteCallBack, dataParam);
	},
	//데이터 상태 팝업
	createConditionPopUpDate:function(obj) {
		popUpId = obj;
		var dataApi = dataUrl.createAPI('GET', 'status', obj);
		ajaxFrame.ajaxDataCall('GET', dataApi, 'json', true, createFunc.createConditionPopCallBack);
	},
	createDayCheckData:function(obj) {
		if(advId != null) {
			var param = '?adv_id=' + advId + '&rept_type=' + obj;
			var dataApi = dataUrl.createAPI('GET', 'saveCheck', param);
			ajaxFrame.ajaxDataCall('GET', dataApi, 'json', false, createFunc.createSaveDayCheckCallBack);
		}
	},
	createWeekCheckData:function(obj) {
		var param = '?adv_id=' + advId + '&rept_type=' + obj;
		var dataApi = dataUrl.createAPI('GET', 'saveCheck', param);
		ajaxFrame.ajaxDataCall('GET', dataApi, 'json', false, createFunc.createSaveWeekCheckCallBack);
	},
	createListHistoryIdData:function() {

	},
	//CallBack Functions
	//데이터 생성 리스트
	createHistoryCallBack:function(data) {
		var dataFilter = data.data;
		var historyHtml = '';
		var listCount = dataFilter.length;
		var $more = $('.data_more');
		var $count = $('#create-count');
		var $list = $('#create-list');
		if(listCount > 0) {
			for (var i = 0; i < listCount; i++) {
				var reptType = (dataFilter[i].rept_type == 'custom') ? '일반':'예약';
				var result = (dataFilter[i].result_cd == 'complete') ? '완료' : (dataFilter[i].result_cd == 'fail' ? '실패':(dataFilter[i].result_cd == 'ready') ? '':'진행');
				var descriptionData = eval("("+dataFilter[i].description_json+")");
				var addDate = descriptionData.call_date_at;
				var comDate = descriptionData.complete_date_at;
				var conditionColor = (result == '진행') ? 'blue':(result == '실패') ? 'red':'';

				historyHtml += "<tr class='list-num-" + i + "' data-id='" + dataFilter[i].id + "'>";
				historyHtml += 	"<td><input type='checkbox' class='list-check' id='reservation" + i + "' onclick='createFunc.createBtnOnOffEvent();'><label for='reservation" + i + "'></label></td>";
				historyHtml += 	"<td>" + reptType+ "</td>";
				historyHtml += 	"<td>" + dataFilter[i].work_name + "</td>";
				historyHtml += 	"<td class='condition_btn'>";
				historyHtml += 	"<span style='color:" + conditionColor + ";'>" + result + "</span>";
				historyHtml += 	"<span class='condition-icon'><a href='javascript:void(0);' id='condition-btn" + i + "' onclick='javascript:layerPopup.open(this, this.id);' class='layer-pop-open' data-name='createCondition' data-id='list-num-" + i + "'><img src='/image/common/eye_btn.png' alt=''></a></span>";
				historyHtml += 	"</td>";
				historyHtml += 	"<td>" + addDate + "</td>"
				if(result != '실패') {
					historyHtml += 	"<td>" + comDate + "</td>";
				}else{
					historyHtml += 	"<td></td>";
				}
				if(result != '실패' || result != '완료') {
					historyHtml += 	"<td align='center' class='box_btn' ><button type='button' data-comment='type-1' onclick='createList.listDeleteBtn(this);'' data-id='list-num-" + i + "'>삭제</button></td>";
				}else if(result == '진행'){
					historyHtml += 	"<td align='center' class='box_btn' ><button type='button' data-comment='type-2' onclick='createList.listDeleteBtn(this);'' data-id='list-num-" + i + "'>삭제</button></td>";
				}else{
					historyHtml += 	"<td align='center' class='box_btn' ><button type='button' data-comment='type-2' disabled onclick='createList.listDeleteBtn(this);'' data-id='list-num-" + i + "'>삭제</button></td>";
				}
				historyHtml += "</tr>";


				listData['type' + dataFilter[i].id] = reptType;
				listData['work' + dataFilter[i].id] = dataFilter[i].work_name;

			}

			$more.show();
		}else{
			historyHtml += "<tr>";
			historyHtml += 	"<td colspan='7'><div class='none_date'><img src='/image/none_date_img.jpg' alt=''></div></td>";
			historyHtml == "</tr>";

			$more.hide();
		}
		$count.text(listCount);
		$list.html(historyHtml);
	},
	//데이터 생성 (생성)
	createAddCallBack:function(data) {
		setTimeout(function() {
			createFunc.createListCall(advId, 'sync');
			alwaysFunc.headerNewsData(advId);
			$('#timeLoading').remove();
		}, 2000);
	},
	//데이터 생성 (저장)
	createSaveCallBack:function(data) {
		setTimeout(function() {
			createFunc.createListCall(advId, 'sync');
			alwaysFunc.headerNewsData(advId);
			$('#timeLoading').remove();
			alert('저장 되었습니다');
		}, 2000);
	},
	//데이터 상태 팝업
	createConditionPopCallBack:function(data) {
		var dataFilter = data.data;
		var dataMessage = (dataFilter.status == 'complete') ? '데이터 생성이 완료되었습니다' : (dataFilter.status == 'fail' ? '데이터 생성에 실패하였습니다.':'데이터 생성 진행중입니다.');
		var conditionData = {
			'status_neo_raw_data':(dataFilter.status_neo_raw_data == 'complete') ? '완료' : (dataFilter.status_neo_raw_data == 'fail' ? '실패':(dataFilter.status_neo_raw_data == 'ready') ? '':'진행'),
			'status_neo_duple_data':(dataFilter.status_neo_duple_data == 'complete') ? '완료' : (dataFilter.status_neo_duple_data == 'fail' ? '실패':(dataFilter.status_neo_duple_data == 'ready') ? '':'진행'),
			'status_naver_data':(dataFilter.status_naver_data == 'complete') ? '완료' : (dataFilter.status_naver_data == 'fail' ? '실패':(dataFilter.status_naver_data == 'ready') ? '':'진행'),
			'status_integrate_data':(dataFilter.status_integrate_data == 'complete') ? '완료' : (dataFilter.status_integrate_data == 'fail' ? '실패':(dataFilter.status_integrate_data == 'ready') ? '':'진행'),
			'status_save_db':(dataFilter.status_save_db == 'complete') ? '완료' : (dataFilter.status_save_db == 'fail' ? '실패':(dataFilter.status_save_db == 'ready') ? '':'진행')
		};
		var $message = $('#layer-message');
		var $type = $('#layer-type');
		var $date = $('#layer-date');
		var $title = $('.popup-title');
		var $body = $('.popup-body');
		var $layer = $('.layer-pop');


		var popTitle = "상태";
		var popHtml = "<div id='condition-popup' class='condition-popup-wrap'>";
		popHtml += 		"<div class='condition-table-area'>";
		popHtml +=			"<div class='condition-list'>";
		popHtml += 				"<div class='condition-name'>NEO 데이터 수급</div>";
		popHtml += 				"<div class='condition-result'>"+ conditionData.status_neo_raw_data + "</div>";
		popHtml +=			"</div>";
		popHtml +=			"<div class='condition-list'>";
		popHtml += 				"<div class='condition-name'>NEO 데이터 중복 필터</div>";
		popHtml += 				"<div class='condition-result'>" + conditionData.status_neo_duple_data + "</div>";
		popHtml +=			"</div>";
		popHtml +=			"<div class='condition-list'>";
		popHtml += 				"<div class='condition-name'>네이버 광고 데이터 수급</div>";
		popHtml += 				"<div class='condition-result'>" + conditionData.status_naver_data +"</div>";
		popHtml +=			"</div>";
		popHtml +=			"<div class='condition-list'>";
		popHtml += 				"<div class='condition-name'>전체 데이터 취합</div>";
		popHtml += 				"<div class='condition-result'>" + conditionData.status_integrate_data + "</div>";
		popHtml +=			"</div>";
		popHtml +=			"<div class='condition-list'>";
		popHtml += 				"<div class='condition-name'>데이터 정제(DB 저장)</div>";
		popHtml += 				"<div class='condition-result'>" + conditionData.status_save_db + "</div>";
		popHtml +=			"</div>";
		popHtml += 		"</div>";
		popHtml += 	"</div>";


		$message.text(dataMessage);
		$type.text(listData['type' + popUpId]);
		$date.text(listData['work' + popUpId]);
		$title.text(popTitle);
		$body.html(popHtml);
		$layer.fadeIn(200);
	},
	//데이터 생성 삭제 (단일)
	createListDeleteCallBack:function(data) {
		createFunc.createListCall(advId);
		alwaysFunc.headerNewsData(advId);
		var newsLength = null;
		$('#my-news-data').find('li').each(function(length) {
			newsLength = length;
		});
		if(newsLength == null) {
			$('.new-icon').removeClass('active');
		}else{
			$('.new-icon').addClass('active');
		}
	},
	//데이터 생성 선택 리스트 삭제
	createListAllDeleteCallBack:function(data) {
		alert('선택된 리스트가 삭제되었습니다');
		createFunc.createListCall(advId);
		alwaysFunc.headerNewsData(advId);
		var newsLength = null;
		$('#my-news-data').find('li').each(function(length) {
			newsLength = length;
		});
		if(newsLength == null) {
			$('.new-icon').removeClass('active');
		}else{
			$('.new-icon').addClass('active');
		}
	},
	createSaveDayCheckCallBack:function(data) {
		var dataFilter = data.data;
		if(0 < dataFilter.length) {
			$("#daily").prop('checked', true);
		}else{
			$("#daily").prop('checked', false);
		}
	},
	createSaveWeekCheckCallBack:function(data) {
		var dataFilter = data.data;
		if(0 < dataFilter.length) {
			$("#weekly").prop('checked', true);
		}else{
			$("#weekly").prop('checked', false);
		}
	},
	createBtnOnOffEvent:function() {
		if( $('.list-check:checked').length == 0 ){
			$('.check-btn').prop('disabled',true);
		}else{
			$('.check-btn').prop('disabled',false);
		}
	},
};


favoriteFunc.init();
window.createFunc = createFunc;



// WEBPACK FOOTER //
// ./js/controller/assets/sub/createFunc.js